module.exports = __webpack_public_path__ + "static/media/logo.5af25e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/prior/logo.png
// module id = 656
// module chunks = 0